import type { Content } from '~/types/blog'
import { resolveImageAssetUrl } from '~/composables/useAssetUrl'
import { normalizeFieldText } from '~/composables/useCustomFields'

type SiteDataState = {
  setting?: {
    customFields?: Record<string, unknown>
  }
} | null

function getRandomPostCoverPool() {
  const siteData = useState<SiteDataState>('site-data')
  const raw = normalizeFieldText(siteData.value?.setting?.customFields, 'randomPostCoverPool', '')
  return raw
    .split('\n')
    .map(item => item.trim())
    .filter(Boolean)
}

function buildPostCoverSeed(item?: Partial<Content> | null) {
  if (!item) {
    return 'post-cover:fallback'
  }
  return String(item.ID || item.slug || item.title || 'post-cover:fallback')
}

function getPostCoverRandomSeed() {
  const seed = useState<string>('post-cover-random-seed', () => Math.random().toString(36).slice(2))
  return String(seed.value || '')
}

function hashText(input: string) {
  let hash = 0
  for (let i = 0; i < input.length; i += 1) {
    hash = ((hash << 5) - hash) + input.charCodeAt(i)
    hash |= 0
  }
  return Math.abs(hash)
}

export function resolvePostCover(input?: string | null, item?: Partial<Content> | null) {
  const cover = String(input || '').trim()
  if (cover) {
    return resolveImageAssetUrl(cover)
  }
  const pool = getRandomPostCoverPool()
  if (!pool.length) {
    return ''
  }
  const index = hashText(`${getPostCoverRandomSeed()}:${buildPostCoverSeed(item)}`) % pool.length
  return resolveImageAssetUrl(pool[index])
}
